<div class="revenue-card" [class]="data.colorClass">
  <div class="card-content">
    <div class="card-title">{{ data.title }}</div>

    <div class="amount-section">
      <div class="amount">{{ formatCurrency(animatedAmount) }}</div>
      <div
        class="percentage-change"
        [class.positive]="isPositiveChange(data.percentageChange)"
        [class.negative]="!isPositiveChange(data.percentageChange)"
      >
        <i
          [class]="
            isPositiveChange(data.percentageChange)
              ? 'pi pi-arrow-up'
              : 'pi pi-arrow-down'
          "
        ></i>
        {{ formatPercentage(animatedPercentageChange) }}
      </div>
    </div>

    <div class="metrics-section">
      <div class="metric">
        <div class="metric-row">
          <span class="metric-label">Orders</span>
          <span class="metric-value">{{ formatNumber(animatedOrders) }}</span>
          <span
            class="metric-change"
            [class.positive]="isPositiveChange(data.ordersChange)"
            [class.negative]="!isPositiveChange(data.ordersChange)"
          >
            {{ formatPercentage(animatedOrdersChange) }}
          </span>
        </div>
      </div>

      <div class="metric">
        <div class="metric-row">
          <span class="metric-label">AOV</span>
          <span class="metric-value" *ngIf="hasAovData()">{{
            formatCurrency(animatedAov)
          }}</span>
          <span class="metric-value metric-na" *ngIf="!hasAovData()">N/A</span>
          <span
            class="metric-change"
            *ngIf="hasAovData()"
            [class.positive]="isPositiveChange(data.aovChange)"
            [class.negative]="!isPositiveChange(data.aovChange)"
          >
            {{ formatPercentage(animatedAovChange) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
